import { title } from 'process';
import ListItem from '../../../../components/card/listItem/listItem';
import { useEffect, useState } from 'react';
import { setHeaderTitle } from '../../../../redux/headerTitle/headerTitleSlice';
import { useDispatch } from 'react-redux';
import CustomisedButton from '../../../../components/button/button';
import ApplyRequestStepsSkeleton from './applyRequestStepsSkeleton';
import BadgeOutlinedIcon from '@mui/icons-material/BadgeOutlined';
import HomeWorkOutlinedIcon from '@mui/icons-material/HomeWorkOutlined';
import ListAltIcon from '@mui/icons-material/ListAlt';
import { IListItem } from '../../../../components/card/listItem/IListItem';
import { IDropDownResponse, IFinalizeByCustomerResponse, IGetRegistrationFormsResponse, IRefrenceKeyRequest } from '../../../../models/registration.model';
import { useMutation, useQuery } from 'react-query';
import { finalizeByCustomer, getRegistrationDuration, getRegistrationForms } from '../../../../services/registration.service';
import BusinessCenterOutlinedIcon from '@mui/icons-material/BusinessCenterOutlined';
import LocalAtmIcon from '@mui/icons-material/LocalAtm';
import { IFormInnerState, TInnerStateForm } from '../IFormInnerState';
import { changeRouteType } from '../../../../redux/handleBackBtn/handleBackBtnSlice';
import { useAppBar } from '../../../../components/appBar/appBarContext';
import GroupsIcon from '@mui/icons-material/Groups';
import DescriptionIcon from '@mui/icons-material/Description';
import { v4 as uuid } from 'uuid';
import { toast } from 'react-toastify';
import ConfirmDeleteModal from '../../../../components/modal/confirmDeleteModal';
import CheckIcon from '@mui/icons-material/Check';

export default function ApplyRequestSteps({ setFormInnerState, setStep, referenceKey }: IFormInnerState) {
    const [openVerifyModal, setOpenVerifyModal] = useState(false);
    const [confirm, setConfirm] = useState(false);

    const [referenceKeyVal, setReferenceKeyVal] = useState<IRefrenceKeyRequest>({ referenceKey: referenceKey! });
    const [formsData, setFormsData] = useState<IGetRegistrationFormsResponse[]>([]);
    const [disableBtn, setDisableBtn] = useState<boolean>(false);
    const dispatch = useDispatch();
    const { setHeader } = useAppBar();
    useEffect(() => {
        dispatch(changeRouteType({ routeType: 'infoDetail' }));
        setHeader('مراحل ثبت درخواست', 'TODO')
    }, [])
    // useEffect(() => {
    //     dispatch(
    //         setHeaderTitle({
    //             header: 'مراحل ثبت درخواست',
    //             color: '#fff !important',
    //         })
    //     );
    // }, [dispatch]);




    useEffect(() => {
        if (confirm === true) {
            finalizeForms()
        }
    }, [confirm])


    let { data, isLoading, isFetching } = useQuery<IGetRegistrationFormsResponse[]>(
        "getRegistrationForms",
        (): Promise<IGetRegistrationFormsResponse[]> => {
            return getRegistrationForms(referenceKeyVal);
        },
        {
            onSuccess: (data) => {
                if (data == null || data.length == 0) {
                    toast.error("لیست مراحل ثبت درخواست خالی است.")
                }
                setFormsData(data);
                data.some((item: IGetRegistrationFormsResponse, index: number) => {

                    if (!(item.formState.toLowerCase() === "ReadyForSend".toLowerCase() || item.formState.toLowerCase() === 'Completed'.toLowerCase())) {
                        setDisableBtn(true)
                    }
                })
            }
        },
    );
    let rejectItem = ["Rejected"];
    let completedItem = ["Completed"];






    const finalizeByCustomerMutation = useMutation(
        finalizeByCustomer,
        {
            onSuccess: (data: IFinalizeByCustomerResponse) => {
                setOpenVerifyModal(false);
                setConfirm(false);
                if (data != null) {
                    if (data.isValid) {
                        //TODO
                        // add setstep to change flow and call api:GetLoanInfo
                        setStep(uuid);
                    } else {
                        setFormsData(data.forms);
                    }
                }
            },
        }
    );

    const finalizeForms = () => {
        finalizeByCustomerMutation.mutate(referenceKeyVal);

    }


    if (isLoading) {
        return <ApplyRequestStepsSkeleton />;
    }

    const handleItemClick = (form: any, state: string) => {
        if (!completedItem.includes(state)) {
            setFormInnerState!(form)
        }

    }


    function handleFinalizeForms() {
        setOpenVerifyModal(true);

    }



    return (
        <>
            <div className='container-height-drawer '>
                <div className='content-container'>
                    <div className='drawer-content'>
                        {(formsData != null && formsData != undefined) ? formsData.map((item: IGetRegistrationFormsResponse) => (
                            <ListItem

                                title={item.formTitle}
                                status={item.formStateTitle}
                                specialStatus={item.formStateTitle == 'آماده ارسال' ? <div style={{ display: 'flex' }}>
                                    <CheckIcon style={{ color: '#BBA57A', width: '12px', height: '12px' }} />
                                    <span className="font-normal text-xs primaryColorLight-100" style={{ float: "right", fontSize: "12.5px" }}>
                                        {item.formStateTitle}
                                    </span>
                                </div> : null}
                                id={item.sortIndex}
                                onClick={() => handleItemClick(item.form, item.formState)}
                                isShown={true}
                                //     {
                                //     setFormInnerState!(item.form)
                                // }}

                                icon={item.form == "Identity" ? <BadgeOutlinedIcon
                                    className={rejectItem.includes(item.formState) ? "primaryErrorColorLight" : "primaryColorLight-100"}
                                    style={{ width: '24px', height: '24px', marginBottom: "10px" }}
                                /> : item.form == "Residential" ? <HomeWorkOutlinedIcon
                                    className={rejectItem.includes(item.formState) ? "primaryErrorColorLight" : "primaryColorLight-100"}
                                    style={{ width: '24px', height: '24px', marginBottom: "10px" }}
                                /> : item.form == "Incomes" ? <BusinessCenterOutlinedIcon
                                    className={rejectItem.includes(item.formState) ? "primaryErrorColorLight" : "primaryColorLight-100"}
                                    style={{ width: '24px', height: '24px', marginBottom: "10px" }}
                                /> : item.form == "Cheque" ? <LocalAtmIcon
                                    className={rejectItem.includes(item.formState) ? "primaryErrorColorLight" : "primaryColorLight-100"}
                                    style={{ width: '24px', height: '24px', marginBottom: "10px" }}
                                /> : item.form == "Guarantors" ? <GroupsIcon
                                    className={rejectItem.includes(item.formState) ? "primaryErrorColorLight" : "primaryColorLight-100"}
                                    style={{ width: '24px', height: '24px', marginBottom: "10px" }}
                                /> :
                                    item.form == "AdditionalFields" ? <DescriptionIcon
                                        className={rejectItem.includes(item.formState) ? "primaryErrorColorLight" : "primaryColorLight-100"}
                                        style={{ width: '24px', height: '24px', marginBottom: "10px" }}
                                    />
                                        : <ListAltIcon
                                            className={rejectItem.includes(item.formState) ? "primaryErrorColorLight" : "primaryColorLight-100"}
                                            style={{ width: '24px', height: '24px', marginBottom: "10px" }}
                                        />}
                                borderColor={undefined}
                                color={rejectItem.includes(item.formState) ? "primaryErrorColorLight" : undefined}
                                infoIcon={completedItem.includes(item.formState) ? <CheckIcon style={{ color: '#BBA57A', width: '24px', height: '24px' }} /> : undefined}
                            ></ListItem>
                        )) : <></>}
                    </div>
                    <div className="py-5">
                        <CustomisedButton
                            title={'ارسال مدارک'}
                            disable={disableBtn}
                            onClick={handleFinalizeForms}
                            type="submit"
                        />
                    </div>
                    {/* <ApplyRequestStepsSkeleton/> */}
                </div>
            </div>
            <ConfirmDeleteModal text={"آیا از صحت  اطلاعات و مدارک ثبت شده اطمینان دارید؟"}
                buttonTitle={'تایید'}
                delButton={false}
                openModal={openVerifyModal}
                setOpenVerifyModal={setOpenVerifyModal}
                setConfirm={setConfirm}
            />
        </>
    );
}
